import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-logo">
          <h3>Faith Tabernacle Church</h3>
          <p className="tagline"><span className="eternity-matters">#EternityMatters</span></p>
          
          {/* Social Icons - Desktop Only */}
          <div className="footer-social-container">
            <a href="https://www.facebook.com/ftckettering/" target="_blank" rel="noopener noreferrer" className="social-icon">
              <img src="/facebook.png" alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/ftckettering/" target="_blank" rel="noopener noreferrer" className="social-icon instagram-icon">
              <div className="instagram-gradient"></div>
              <img src="/instagram.png" alt="Instagram" />
            </a>
          </div>
        </div>
        <p className="copyright">&copy; 2026 Faith Tabernacle Church. All Rights Reserved.</p>
        <div className="footer-info">
          <p>
            Faith Tabernacle Church is part of the Assemblies of God UK (AoG), a network comprising over 500 churches across the UK. Located in Kettering, Faith Tabernacle Church is registered as a charity under the Charity Commission in England, UK. The official charity name is Faith Tabernacle Church Kettering, with the charity number: 1198324.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
